{
	"title": "Documentos e exportações",
	"read": "Todos",
	"unread": "Não lidos",
	"emptyNotifications": "Você chegou no final da lista!",
	"emptyUnreadNotifications": "Você está atualizado de todas as notícias!",
	"noNews": "Sem novidades!",
	"levelTag": "Nível {{tag}}",
	"classification": {
		"alert": "Instabilidade",
		"release": "Lançamento",
		"warning": "Melhoria"
	},
	"level": {
		"app": "App do usuário",
		"organization": "Organização",
		"place": "Local",
		"event": "Evento",
		"pdv": "Pdv"
	},
	"onboarding": {
		"allGood": "Está tudo bem aqui!",
		"markReadAll": "Marcar tudo como lido",
		"read": "Lida",
		"unread": "Não lida",
		"markUnread": "Marcar como não lida",
		"markRead": "Marcar como lida",
		"open": "Navegar",
		"notification": "Notificação",
		"description": "Como você gostaria de visualizar suas notificações?",
		"notificationsModal": "Em uma janela",
		"notifications": "Em uma página completa",
		"readDuration": "Tempo de leitura: 1 minuto",
		"modularization": {
			"title": "Introduzindo <strong>Novo Menu Zig</strong>",
			"content": "<strong>Agora você pode...</strong> visualizar seu histórico financeiro de forma detalhada e personalizada, com filtros avançados e relatórios que facilitam o acompanhamento das suas transações.",
			"primaryActionLabel": "Saiba mais",
			"secondaryActionLabel": "Pular"
		},
		"bonusReport": {
			"title": "Acompanhe os bônus concedidos e utilizados",
			"content": "Agora você pode acompanhar os bônus concedidos e utilizados a partir de relatórios detalhados com o total distribuído, nome do cliente, colaborador, motivo e valor. Veja agora o novo relatório acessando a aba de Bônus nos relatórios financeiros do seu local.",
			"primaryActionLabel": "Fechar"
		},
		"salesReport": {
			"title": "Agora é chamado de Relatórios de Vendas!",
			"content": "O antigo Relatório de Bar ainda existe, mas agora ele se chama Relatórios de Vendas. Para acessá-lo, vá até o menu do local e clique na aba 'Relatórios de Vendas'.",
			"primaryActionLabel": "Fechar"
		}
	},
	"goToInvoices": "Ir para notas fiscais",
	"xmlZipError": "Download com erro",
	"xmlZipSuccess": "Download concluído",
	"downloadInvoicesTitle": "Download de notas fiscais",
	"downloadStarted": "Download iniciado",
	"downloadMessage": "O arquivo zip estará disponível nas suas notificações em breve.",
	"backToInvoices": "Voltar para notas fiscais"
}
